import { throttle } from "../../utils/helpers"
import { timeStringToSeconds } from "../../utils/videoHelpers"

export const handleTranscript = (
  videoComponentEl,
  videoPlayerEl,
  videoId,
  baseClass,
) => {
  let userScrolled = false
  let highlightTranscriptLine
  let transcriptVisible = false

  // Try to find transcript button and transcript element using multiple selector patterns
  let transcriptBtnEl = videoComponentEl.querySelector(
    `.${baseClass}__transcript-btn`,
  )
  let transcriptEl = videoComponentEl.querySelector(`.${baseClass}__transcript`)

  // Fallback: check for paragraph video selectors (video--livestream)
  if (!transcriptBtnEl || !transcriptEl) {
    transcriptBtnEl = videoComponentEl.querySelector(
      ".video--livestream__transcript-btn",
    )
    transcriptEl = videoComponentEl.querySelector(
      ".video--livestream__transcript",
    )
  }

  if (!transcriptBtnEl || !transcriptEl) {
    return
  }

  const formattedDataSetProp =
    videoId.charAt(0).toUpperCase() + videoId.slice(1).toLowerCase()

  // ******** Event Handlers ********
  function handleTranscriptButtonClick() {
    const isActive = transcriptEl.dataset.show === "true"

    if (isActive) {
      // Hide with slide animation
      transcriptEl.dataset.animating = "true"
      const height = transcriptEl.scrollHeight
      transcriptEl.style.height = `${height}px`

      // Force reflow
      transcriptEl.offsetHeight

      transcriptEl.style.height = "0px"
      transcriptEl.style.opacity = "0"

      setTimeout(() => {
        transcriptEl.dataset.show = "false"
        transcriptEl.dataset.animating = "false"
        transcriptEl.style.height = ""
        transcriptEl.style.opacity = ""
        transcriptVisible = false
      }, 300) // Match CSS transition duration

      // Update button text
      transcriptBtnEl.textContent = "Show Transcript"
    } else {
      // Show with slide animation
      transcriptEl.dataset.show = "true"
      transcriptEl.dataset.animating = "true"
      transcriptEl.style.height = "0px"
      transcriptEl.style.opacity = "0"

      // Force reflow
      transcriptEl.offsetHeight

      const height = transcriptEl.scrollHeight
      transcriptEl.style.height = `${height}px`
      transcriptEl.style.opacity = "1"

      setTimeout(() => {
        transcriptEl.style.height = ""
        transcriptEl.dataset.animating = "false"
        transcriptVisible = true
        // Trigger the transcript highlighting after animation
        highlightTranscriptLine()
      }, 300) // Match CSS transition duration

      // Update button text
      transcriptBtnEl.textContent = "Hide Transcript"
    }
  }

  function onUserScroll() {
    userScrolled = true
  }

  transcriptBtnEl.addEventListener("click", handleTranscriptButtonClick)
  transcriptEl.addEventListener("scroll", onUserScroll)

  // ******** Transcript Highlighting ********
  function scrollToHighlighted(transcriptEl, highlightedEl) {
    if (!transcriptEl || !highlightedEl || userScrolled) return

    highlightedEl.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
    })
  }

  if (transcriptBtnEl && transcriptEl) {
    // Todo: determine if there is a situation where the transcript is open by default
    // transcriptVisible = transcriptEl.dataset.show === "true"

    const dataSetProp = `timeStamp${formattedDataSetProp}`
    const transcriptLines = transcriptEl.querySelectorAll(
      `[data-time-stamp-${formattedDataSetProp}]`,
    )

    highlightTranscriptLine = function () {
      if (transcriptLines.length === 0) return

      const currentVideoTimestamp = videoPlayerEl.currentTime
        .toFixed(0)
        .toString()

      transcriptLines.forEach((el, currentIndex, arr) => {
        const arrLength = arr.length - 1
        const currentTime = el.dataset?.[dataSetProp]

        if (!currentTime) {
          console.warn(
            `No attribute found on element with prop ${dataSetProp}:`,
            el,
            `dataset-list:`,
            el.dataset,
          )
          return
        }

        const isLastEl = currentIndex === arrLength
        const isFirstEl = currentIndex === 0

        // Next and previous elements
        const nextEl = !isLastEl && transcriptLines[currentIndex + 1]
        const prevEl = !isFirstEl && transcriptLines[currentIndex - 1]

        const nextTime = nextEl && nextEl.dataset[dataSetProp]
        const prevTime = prevEl && prevEl.dataset[dataSetProp]

        // Convert minutes:seconds to total seconds
        const currentTimeFormated = timeStringToSeconds(currentTime)
        const nextTimeFormated = nextTime && timeStringToSeconds(nextTime)
        const prevTimeFormated = prevTime && timeStringToSeconds(prevTime)

        const isAfterPrev = prevTimeFormated
          ? currentVideoTimestamp > prevTimeFormated
          : true
        const isBeforeNext = nextTimeFormated
          ? currentVideoTimestamp < nextTimeFormated
          : true
        const currentTimeGreaterThanVideoTimestamp =
          currentVideoTimestamp >= currentTimeFormated

        const shouldHighlight =
          currentTimeGreaterThanVideoTimestamp && isAfterPrev && isBeforeNext

        const isActive = el.classList.contains("active")
        if (isActive) {
          scrollToHighlighted(transcriptEl, el)
        }

        if (shouldHighlight) {
          el.classList.add("active")
        } else {
          el.classList.remove("active")
        }

        el.addEventListener(
          "click",
          () => (videoPlayerEl.currentTime = currentTimeFormated),
        )
      })
    }

    const throttledTimeUpdate = throttle(() => {
      if (transcriptVisible && highlightTranscriptLine) {
        highlightTranscriptLine()
      }
    }, 1000)

    videoPlayerEl.addEventListener("timeupdate", throttledTimeUpdate)
  }
}
